import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Detect Capacitor native shell (WebView origin is https://localhost or
// capacitor://localhost — different from the API origin, so the request
// becomes cross-origin). The Kubernetes ingress responds to preflights with
// `Access-Control-Allow-Origin: *`, which browsers refuse to combine with
// credentials. Native apps use Bearer-token auth (set by interceptor below),
// so we can safely disable cookie credentials when running inside Capacitor.
const isNativeApp =
  typeof window !== "undefined" &&
  (!!window.Capacitor?.isNativePlatform?.() ||
    window.location.protocol === "capacitor:" ||
    window.location.hostname === "localhost");

export const api = axios.create({
  baseURL: API,
  withCredentials: !isNativeApp,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function authFileUrl(storagePath) {
  const token = localStorage.getItem("auth_token") || "";
  return `${API}/files/${storagePath}?auth=${encodeURIComponent(token)}`;
}
